import {
  ONBOARDING_V3_PAGE,
  INDEX_PAGE,
  ONBOARDING_EXPERIENCE_MODAL,
  JOBS_ONBOARDING_PAGE,
  WAR_ROOM_POSTS_PAGE,
  SALES_COMPENSATION_2022_PAGE,
  LOGIN_EXTERNAL_PAGE,
  REDIRECT_PAGE,
  CONTENT_LOBBY_PAGE,
  WAIT_LIST_SKWSLUG_COMPLETE_PAGE,
  LANDING_ALL_PAGE,
  CONNECTIONS_CONTACT_PAGE,
  CONNECTIONS_SYNC_PAGE,
} from '@/constants';
import type { Middleware } from '@nuxt/types';
import { ONBOARDING_TOOLTIP_NAME } from '~/components/partials/war-room-onboarding/constants';
import { warRoomStates } from '~/components/partials/war-room/constants';
import { SKIP_ONBOARDING_NAME } from '~/components/partials/war-room/WarRoomSignUp/skipOnboarding';
import { GOOGLE_OAUTH_KEY } from '~/components/partials/connections/constants';
import type { CurrentUser, IOauthProvider } from '~/types/';

const AVAILABLE_PAGES_FOR_IN_ONBOARDING_STATE = [
  SALES_COMPENSATION_2022_PAGE.name,
  LOGIN_EXTERNAL_PAGE.name,
  REDIRECT_PAGE.name,
  CONTENT_LOBBY_PAGE.name,
  WAIT_LIST_SKWSLUG_COMPLETE_PAGE.name,
  LANDING_ALL_PAGE.name,
];

const userHasGoogleContactPermission = (user: Partial<CurrentUser>) => {
  const { oauthProviders } = user;
  const googleProvider = oauthProviders?.find((provider: IOauthProvider) => provider.name === GOOGLE_OAUTH_KEY);

  return googleProvider && googleProvider.scopes?.some((scope: string) => scope.includes('contact'));
};

const redirectRules: Middleware = ({ app, route, $auth }) => {
  // all rules apply only for loggedIn users
  if (!$auth.loggedIn || !route.name) {
    return;
  }

  if (route.params.stepSlug === CONNECTIONS_SYNC_PAGE.params.stepSlug && userHasGoogleContactPermission($auth.user!)) {
    app.$utils.redirectWithQuery(CONNECTIONS_CONTACT_PAGE);
  }

  // outsider for old users
  if ($auth.user.warRoomState === warRoomStates.OUTSIDER && route.name !== INDEX_PAGE.name) {
    app.$utils.redirectWithQuery(INDEX_PAGE);

    // in_onboarding
  } else if (
    $auth.user.warRoomState === warRoomStates.IN_ONBOARDING &&
    !(route.name.startsWith(JOBS_ONBOARDING_PAGE.name) || route.name.startsWith(ONBOARDING_V3_PAGE.name))
  ) {
    if (AVAILABLE_PAGES_FOR_IN_ONBOARDING_STATE.includes(route.name)) {
      return;
    }

    // GROW-442
    if (app.$cookies.get(SKIP_ONBOARDING_NAME)) {
      return;
    }

    // if user trying to go somewhere else we should redirect to onboarding
    app.$utils.redirectWithQuery(ONBOARDING_V3_PAGE);

    // members
  } else if (
    $auth.user.warRoomState === warRoomStates.MEMBER &&
    !app.$tooltip.isPresent(ONBOARDING_TOOLTIP_NAME) &&
    route.name.startsWith(WAR_ROOM_POSTS_PAGE.name) &&
    !route.query.dynamic_modal
  ) {
    // show modal with onboarding to collect some extra data
    // TODO MOVE SOMEWHERE ELSE
    app.$utils.redirectWithQuery({ query: { dynamic_modal: ONBOARDING_EXPERIENCE_MODAL } });
  }
};

export default redirectRules;
